import produce from 'immer';

import { createReducer, getErrorStatus, getInitialStatus, getPendingStatus } from '../utils';

import { LicensesStore } from '.';
import { FETCH_LICENSES } from './actions';

const initialState: LicensesStore = {
  licenses: {},
  status: getInitialStatus(),
};

export default createReducer<LicensesStore>(initialState, {
  [`${FETCH_LICENSES}_PENDING`]: (state) => produce(state, draftState => {
    draftState.status = getPendingStatus();
  }),
  [`${FETCH_LICENSES}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.status = getInitialStatus();
    action.payload.data.forEach((license) => {
      if (license?.licenseId) {
        draftState.licenses[license.licenseId] = license;
      }
    });
  }),
  [`${FETCH_LICENSES}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status = getErrorStatus(action.payload);
  }),
});
